"use strict";Object.defineProperty(exports, "__esModule", {value: true});




var _chunkWCNPLMX6js = require('../chunk-WCNPLMX6.js');
require('../chunk-Q4G2SZRD.js');





exports.getCounter = _chunkWCNPLMX6js.getCounter; exports.paramsInTree = _chunkWCNPLMX6js.paramsInTree; exports.sendGoalToMetrika = _chunkWCNPLMX6js.sendGoalToMetrika; exports.sendParamsToMetrika = _chunkWCNPLMX6js.sendParamsToMetrika;
//# sourceMappingURL=index.js.map